(() => {
  const product = document.querySelector('.Product');
  if (!product) return;
  const about = product.querySelector('.PPAAbout');
  const info = product.querySelector('.Product__Info > .Container');
  if (about && info) {
    const originalParent = about.parentElement;
    const mobile = matchMedia('(max-width: 760px)');
    const place = () => (mobile.matches ? info : originalParent).append(about);
    place(); mobile.addEventListener('change', place);
  }
})();
